import { render, staticRenderFns } from "./ViewAnalyticsSupplyers.vue?vue&type=template&id=868e37ac&scoped=true&"
import script from "./ViewAnalyticsSupplyers.vue?vue&type=script&lang=js&"
export * from "./ViewAnalyticsSupplyers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868e37ac",
  null
  
)

export default component.exports